module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/map/compass-509587aa172b0fb3f319a1f375e35fa7.svg";